import { memo } from "react";
import { stringify } from "qs";
import "./mail-to-button.scss";
import PropTypes from "prop-types";
import { MailFilledIcon } from "app/icons/profile";
import { ICON_SIZES } from "app/constants";

const MailToButtonComponent = ({ subject, body, label, onClick }) => {
	const onOpenMailbox = () => onClick?.();

	let mailToOptions = {};

	if (subject) {
		mailToOptions.subject = subject;
	}

	if (body) {
		mailToOptions.body = body;
	}

	const mailToQueryString = stringify(mailToOptions, { encode: false });

	return (
		<a
			className="mail-to-button"
			rel="noopener noreferrer"
			target="_blank"
			onClick={onOpenMailbox}
			href={`mailto:?${mailToQueryString}`}
		>
			<span className="mail-to-button__icon">
				<MailFilledIcon size={ICON_SIZES.MD} />
			</span>
			<span className="mail-to-button__label">{label}</span>
		</a>
	);
};

MailToButtonComponent.propTypes = {
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	subject: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	body: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	onClick: PropTypes.func,
};

export const MailToButton = memo(MailToButtonComponent);

export default MailToButton;
